<template>
  <div class="login">
    <div class="all-wrapper menu-side with-pattern">
      <div class="auth-box-w">
        <div class="logo-w">
          <img v-if="!this.missingImage && allTemplateDetails.loginLogoImage" @error="imageError()" :alt="clientName" width="100%" :src="allTemplateDetails.loginLogoImage">
          <img v-else :alt="clientName" width="100%" :src="allTemplateDetails.loginLogoImage">
        </div>
          <h4 class="auth-header">
            {{ t('loginFormHeaderText','Login form') }}
            <div class="translationBox">
              <Translation></Translation>
            </div>
          </h4>
        <ResponseInfo class="px-3" v-if="getResponseInfo.responseName == 'login'" />
        <form class="logInForm" v-on:submit.prevent="logUserIn" autocomplete="off">
          <div class="form-group">
            <label for="">{{ t('loginFormEmailText','loginFormEmailText') }}</label><input :disabled="getSpinner" class="form-control" id="loginUsername" v-model="loginUsername" :placeholder="t('loginFormEmailPlaceholder', 'loginFormEmailPlaceholder')" type="text" required autofocus autocomplete="off">
            <div class="pre-icon os-icon os-icon-user-male-circle"></div>
          </div>
          <div class="form-group">
            <!-- <div @click="showPassword" class="show-pass"><i class="icon-eye"></i></div> -->
            <label style="width:100%;" for="">{{ t('loginFormPasswordText','loginFormPasswordText') }}<label v-if="showForgotButton" style="float:right;"><router-link :to="{ name: 'forgot_password' }" title="Go to the forgot password page.">{{ t('loginFormForgotPasswordText','Forgot password') }}</router-link></label>
            </label>
              <div style="position: relative;">
                <div @click="togglePassword" class="show-pass"><i id="showPasswordIcon" v-bind:class="{ 'os-icon-eye': eyeOn, 'os-icon-eye-off': eyeOff }" class="os-icon" title="Show password"></i></div>
                <input @keypress="checkCapsLock($event)" :disabled="getSpinner" class="form-control add-padding" id="loginPassword" v-model="loginPassword" :placeholder="t('loginFormPasswordPlaceholder', 'loginFormPasswordPlaceholder')" :type="passwordType" required>
              </div>
            <div class="pre-icon os-icon os-icon-lock"></div>
          </div>
          <span class="caps-lock-div" id="capsLockDiv">
            <fontAwesomeIcon :icon="['fas', 'exclamation-triangle']" size="1x" />
            {{ t('capsLockTurnedOn', 'capsLockTurnedOn') }}
            <fontAwesomeIcon :icon="['fas', 'exclamation-triangle']" size="1x" />
          </span>
          <div class="buttons-w row">
          <button type="submit" v-if="!getSpinner" class="btn btn-primary">{{ t('loginFormButtonText','loginFormButtonText') }}</button>
          <div v-if="getSpinner">
            <b-spinner small type="grow"></b-spinner>
          </div>
          </div>
          <br>
          <div v-if="allTemplateDetails.registrationActivated == 1" class="button-w">
              <label><router-link :to="{ name: 'register' }" title="Go to the registration page.">{{ t('loginFormLikeToRegisterText','Let me register') }}</router-link></label>
            <!-- <div v-if="this.$store.state.registrationAllowed" class="row">
              <label for=""><router-link :to="{ name: 'signup' }">{{ likeToRegisterText }}</router-link></label>
            </div>
            <div class="row" v-if="displayLogInText">
              <label for=""><router-link :to="{ name: 'signup' }">{{ creditReportText }}</router-link></label>
            </div>
            <div class="row" v-if="displayLogInText">
              <label for=""><router-link :to="{ name: 'signup' }">{{ privacyText }}</router-link></label>
            </div> -->
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import Translation from '@/components/Translation.vue'
import ResponseInfo from '@/components/ResponseInfo.vue'

// @ is an alias to /src
export default {
  name: 'login',
  data(){
    return{
      loginUsername: '',
      loginPassword: '',
      passwordType: 'password',
      eyeOn: true,
      eyeOff: false,
      textDisabled: false,
      missingImage: false,
      cacheValue: new Date().getTime()
    }
  },
  components: {
    Translation,
    ResponseInfo
  },
  methods: {
      logUserIn(){
        this.$store.dispatch('alertClearResponse')
        this.$store.dispatch('logIn',{
          loginUsername: this.loginUsername,
          loginPassword: this.loginPassword
        })
      },
      changeBackgroud(){
        if(this.$store.getters.allTemplateDetails.loginBackgroundImage) {
          document.body.style.backgroundAttachment = "fixed";
          document.body.style.transition = "background-image 0.2s ease-in-out";
          document.body.style.backgroundImage = "url("+this.$store.getters.allTemplateDetails.loginBackgroundImage+ '?' + this.cacheValue+")";
        } else {
          document.body.style.backgroundImage = "linear-gradient(to top, #00c6fb 0%, #005bea 100%)";
        }        
      },
      togglePassword() {
        this.passwordType == "password" ? this.passwordType = "text" : this.passwordType = "password";
        if(this.eyeOn){
          this.eyeOn = false;
          this.eyeOff = true;
        }else{
          this.eyeOn = true;
          this.eyeOff = false;
        }
      },
      imageError() {
        this.missingImage = true
      },
      checkCapsLock(event) {
        let capsLockDiv = document.getElementById("capsLockDiv");
        if(event.getModifierState('CapsLock')) {
          capsLockDiv.style.display = "block";
        } else {
          capsLockDiv.style.display = "none";
        }
      }
  },
  computed: {
      ...mapGetters(['allTemplateDetails', 'getSpinner', 'getResponseInfo']),
      showForgotButton() {
        if(this.$store.getters.allTemplateDetails.allow_password_hints == 1 || this.$store.getters.allTemplateDetails.allow_password_reminders == 1 || this.$store.getters.allTemplateDetails.allow_password_resets == 1) {
          return true;
        } else {
          return false;
        }
      },
      clientName() {
        let clientName = clientShortName()
        return clientName
      },
      imagesUrls() {
        return  "url(" + this.$store.getters.allTemplateDetails.loginBackgroundImage
      }
  },
  watch: {
    imagesUrls (newUrls, oldUrls) { 
      if(this.$store.getters.allTemplateDetails.loginBackgroundImage) {
        document.body.style.backgroundAttachment = "fixed";
        document.body.style.transition = "background-image 0.2s ease-in-out";
        document.body.style.backgroundImage = "url("+this.$store.getters.allTemplateDetails.loginBackgroundImage+ '?' + this.cacheValue+")";
      } else {
        document.body.style.backgroundImage = "linear-gradient(to top, #00c6fb 0%, #005bea 100%)";
      } 
    }
  },
  created(){
    this.changeBackgroud()
    window.onload = function(e) {
      // autofocus username input on page load
      document.getElementById("loginUsername").focus();
    }
  }
}
</script>

<style scoped>
  .show-pass {
    position: absolute;
    right: 10px;
    bottom: 0;
    top: 0;
    display: flex;
    align-items: center;
  }
  .show-pass > .os-icon-eye,  .show-pass > .os-icon-eye-off{
    font-size: 24px;
    color: rgba(4, 121, 246, 0.50);
  }
  .buttons-w{
    padding-left: 15px;
  }
  .add-padding{
    padding-right: 45px;
  }
  .caps-lock-div {
    width: 100%;
    padding: 5px;
    display: none;
    text-align: center;
    color: #7e780c;
    background-color: rgba(255, 255, 0, 0.3);
    border: 1px solid #cc0;
  }
</style>
